<template>
    <div class="wallet">
        <nav-bar></nav-bar>
        <div :class="isMobile ? 'm-content' : 'content'">
            <div class="box">
                <div class="box-left" v-if="!isMobile">
                    <p class="title">{{ $t('钱包信息') }}</p>
                    <p class="int">{{ $t('如果您需要修改存款地址，请联系最新的在线客服进行修改') }}</p>
                </div>
                <div class="box-right">
                    <div class="title">{{ $t('钱包信息') }}</div>
                    <el-input  v-model="address" :placeholder="$t('请输入钱包地址')"></el-input>
                    <el-input  v-model="password" :placeholder="$t('请输入提款密码')" show-password></el-input>
                    <!-- <el-input v-if="!isSet" v-model="confirm_password" :placeholder="$t('请重新输入密码')" show-password></el-input> -->
                    <div class="btn">
                        <el-button @click="submit">{{ $t('绑定') }}</el-button>
                    </div>
                </div>
            </div>
        </div>
        <footers v-if="!isMobile"></footers>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { address, add_address } from '../../api/index'
export default {
    data() {
        return {
            address: '',
            password: '',
            confirm_password: '',
            isSet: false,
        }
    },
    computed: {
        ...mapGetters("device", ["isMobile"]),
    },
    created() {
        this.getAddress()
    },
    methods: {
        // 提款列表
        getAddress() {
            address().then(res=> {
                if (res.code == 0) {
                    this.address = res.data.info ? res.data.info.usdt_diz : ''
                    this.isSet = this.address ? true : false
                }
            })
        },
        submit() {
            if (!this.address) {
                return this.$message({
                            message: this.$t('请输入钱包地址'),
                            type: 'warning'
                        });
            }
            if (!this.password) {
                return this.$message({
                            message: this.$t('请输入密码'),
                            type: 'warning'
                        });
            }
            // if (!this.confirm_password) {
            //     return this.$message({
            //                 message: this.$t('请重新输入密码'),
            //                 type: 'warning'
            //             });
            // }
            add_address({usdt_type: 'TRC20',paypassword: this.password,usdt_diz: this.address}).then(res=> {
                if (res.code == 0) {
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                    this.getAddress()
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .wallet {
        background-color: #fff;
        .content {
            background: #f8f8f8;
            background-image: linear-gradient(-225deg, #2cd8d5, #c5c1ff 56%, #ffbac3);
            background-position: 0;
            background-size: cover;
            display: flex;
            justify-content: center;
            min-height: 100vh;
            width: 100%;

            .box {
                width: 72%;
                margin: 0 auto 60px auto;
                display: flex;
                padding-top: 60px;

                .box-left {
                    flex: 1;
                    padding: 40px;

                    .title {
                        font-size: 64px;
                        color: #fff;
                        font-weight: 800;
                    }

                    .int {
                        font-size: 16px;
                        color: #fff;
                        margin: 0;
                    }
                }

                .box-right {
                    flex: 1;
                    background-color: #fff;
                    border-radius: 9px;
                    padding: 40px;

                    .title {
                        font-size: 24px;
                        height: 100px;
                        line-height: 100px;
                    }

                    :deep(.el-input__inner) {
                        margin-bottom: 20px;
                        border-color: #000;
                        padding: 22px 15px;

                    }

                    .btn {
                        width: 100%;

                        :deep(.el-button) {
                            width: 100%;
                            background-color: #000;
                            color: #fff;
                            padding: 15px 0;
                        }
                    }
                }
            }
        }

        :deep(.el-input__suffix) {
            top: -8px;
        }

        .m-content {
            .box {
                display: flex;

                .box-right {
                    flex: 1;
                    background-color: #fff;
                    border-radius: 9px;
                    padding: 0 10px;

                    .title {
                        font-size: 24px;
                        height: 100px;
                        line-height: 100px;
                    }

                    :deep(.el-input__inner) {
                        margin-bottom: 20px;
                        border-color: #000;
                        padding: 22px 15px;

                    }

                    .btn {
                        width: 100%;

                        :deep(.el-button) {
                            width: 100%;
                            background-color: rgb(236, 174, 56);
                            color: #fff;
                            padding: 15px 0;
                            border-radius: 24px;
                        }
                    }
                }
            }
        }
    }
</style>
